<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
             <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
        </div>
        <div class="container" @mouseleave="showIconsAnimation = false">
            <div class="row justify-content-center" @mouseover="showIconsAnimation = true">
                <div class="col-lg-12 text-center">
                    <h1 class="display-2 text-white">Our Solutions</h1>
                    <p class="lead text-white">
                      We build best-in-class AI solutions to make enterprise intelligence easier than ever. </p>
                </div>

                <div class="col-lg-4 col-md-6">
                  <router-link to="/solutions/autonomous-driving">
                    <card class="border-0" hover shadow body-classes="py-5" style="background-image:url('img/autonomous_drive.jpg');opacity: 1; 
                    height: 200px; background-size: cover; -moz-background-size: cover; background-position: center;">
                    </card>
                  </router-link>
                  <h5 class="text-white text-center" style="margin:10px 0">Autonomous Driving</h5>
                </div>

                <div class="col-lg-4 col-md-6">
                  <router-link to="/solutions/smart-home">
                    <card class="border-0" hover shadow body-classes="py-5" style="background-image:url('img/smart_home.jpg');opacity: 1; 
                    height: 200px; background-size: cover; -moz-background-size: cover; background-position: center;">
                    </card>
                  </router-link>
                  <h5 class="text-white text-center" style="margin:10px 0">Smart Home</h5>
                </div>

                <div class="col-lg-4 col-md-6">
                  <router-link to="/solutions/manufacturing">
                    <card class="border-0" hover shadow body-classes="py-5" style="background-image:url('img/manufacturing.jpg');opacity: 1; 
                    height: 200px; background-size: cover; -moz-background-size: cover; background-position: center;">
                    </card>
                  </router-link>
                  <h5 class="text-white text-center" style="margin:10px 0">Manufacturing</h5>
                </div>

                <div class="col-lg-4 col-md-6">
                  <router-link to="/solutions/smart-retail">
                    <card class="border-0" hover shadow body-classes="py-5" style="background-image:url('img/retail.jpg');opacity: 1; 
                    height: 200px; background-size: cover; -moz-background-size: cover; background-position: center;">
                    </card>
                  </router-link>
                  <h5 class="text-white text-center" style="margin:10px 0">Smart Retail</h5>
                </div>

                <div class="col-lg-4 col-md-6">
                 <router-link to="/solutions/mobile-apps">
                    <card class="border-0" hover shadow body-classes="py-5" style="background-image:url('img/mobile_apps.jpg');opacity: 1; 
                    height: 200px; background-size: cover; -moz-background-size: cover; background-position: center;">
                    </card>
                 </router-link>  
                  <h5 class="text-white text-center" style="margin:10px 0">Mobile Apps</h5>
                </div>

                <div class="col-lg-4 col-md-6">
                  <router-link to="/solutions/robotics">
                    <card class="border-0" hover shadow body-classes="py-5" style="background-image:url('img/robotics.jpg');opacity: 1; 
                    height: 200px; background-size: cover; -moz-background-size: cover; background-position: center;">
                    </card>
                  </router-link>  
                  <h5 class="text-white text-center" style="margin:10px 0">Robotics</h5>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";
export default {
  components: {
    Tabs,
    TabPane
  },
  data() {
    return {
      
    };
  },
  methods: {
    onScroll(evt) {
      console.log(evt);
    }
  }
};
</script>
<style>
</style>
